export function reportError(error, extra = {}) {
  const payload = {
    message: error?.message || String(error),
    stack: error?.stack || '',
    url: window.location.href,
    userAgent: navigator.userAgent,
    app: 'payment-result',
    extra,
  }

  fetch('/api/errors/report/', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  }).catch(() => {})
}

export function setupGlobalErrorHandlers() {
  window.addEventListener('error', (event) => {
    reportError(event.error || new Error(event.message), {
      filename: event.filename,
      lineno: event.lineno,
      colno: event.colno,
    })
  })

  window.addEventListener('unhandledrejection', (event) => {
    const error = event.reason instanceof Error
      ? event.reason
      : new Error(String(event.reason))
    reportError(error, { type: 'unhandledrejection' })
  })
}
